import React, { useEffect, useRef, useState } from "react";
import { Box } from "@material-ui/core";
import apiUtil from "../../api/apiUtil";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import Table from "../../components/Table/Table";
import "./brand.css";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import edit from "../../images/icons/edit.png";
import delete_icon from "../../images/icons/delete.png";
import CustomButton from "../../components/CustomButton/custombutton";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import CustomInput from "../../components/CustomInput/CustomInput";
import api from "../../api/api";
import getToken from "../getToken";

const Brand = () => {
  const [showAddBrand, setShowAddBrand] = useState(false);
  const [showEditBrand, setShowEditBrand] = useState(false);
  const refBrandTable = useRef();
  const refPreviewBrandFiles = useRef(false);
  const refBrandListForm = useRef(null);
  const [detailBrand, setDetailBrand] = useState(null);
  const [keyword, setKeyword] = useState("");

  const clickAddBrand = (e) => {
    e.stopPropagation();
    if (showEditBrand) {
      setShowEditBrand(false);
      setTimeout(() => setShowAddBrand(true), 100);
    } else {
      setShowAddBrand(true);
    }
  };
  const clickBtnClose = () => {
    setShowAddBrand(false);
    setShowEditBrand(false);
  };
  const clickEdit = (rowData) => {
    setDetailBrand({
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      id: rowData.id,
      name: rowData.brandName,
      phone: rowData.phone,
      email: rowData.email,
      address: rowData.address,
      serviceType: rowData.serviceType,
    });
    setShowEditBrand(true);
  };
  const initialValues = {
    name: "",
    phone: "",
    email: "",
    address: "",
    serviceType: "",
  };

  const handleDelete = (rowData) => {
    console.log(rowData);
    if (window.confirm("Are you sure you want to delete this Brand?")) {
      api
        .delete(`Admin/DeleteBrand?brandId=${rowData.id}`, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.code === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.statusCode === 200) {
                alert("Brand deleted successfully!");
                retrieveBrandList();
              } else {
                alert(response.data.message);
              }
            },
            (error) => {
              alert(error);
            }
          );
        });
    }

  };


  const AddBrandFormValidation = Yup.object().shape({
    name: Yup.string().nullable().required("Please enter the name."),
    phone: Yup.string()
      .required("Please enter the phone number.")
      .test(
        "phone",
        "Please enter format phone number. For example, 09xxxxxxxxx (or) 018xxxxxx.",
        (val) => /^\d{2,3}\d{7,9}$/g.test(val)
      ),
    address: Yup.string().required("Please enter the address."),
    serviceType: Yup.string().required("Please enter the service type."),

  });

  const [brandList, setBrandList] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [param, setParam] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb"
  });

  const retrieveBrandList = (value = param) => {
    value.keyword = keyword || "";
    setBrandList({
      ...brandList,
      isLoading: false,
    });

    api.post("Admin/GetBrandList", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            }
            if (response.data.code === 200) {
              if (response.data.data.data != null) {
                setBrandList({
                  isLoading: false,
                  limit: response.data.data.rowLimit,
                  data:
                    response.data.data.data &&
                      response.data.data.data.length > 0
                      ? response.data.data.data
                      : [],
                  total: response.data.data.data.totalRecords,
                  page: response.data.data.paging,
                });
              }
              else {
                setBrandList({
                  isLoading: false,
                  grouping: false,
                  limit: apiUtil.getDefaultPageSize(),
                  data: [],
                  total: 0,
                  page: 0,
                });
              }
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const handleSubmitForm = (values, actions) => {
    const payload = {
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandName: values.name,
      phone: values.phone,
      email: values.email,
      address: values.address,
      serviceType: values.serviceType,
    };

    console.log(payload);

    api.post("Admin/CreateBrand", payload, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            alert("Brand saved successfully!!");

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowAddBrand(false);

            retrieveBrandList();
            for (let i = 0; i < refBrandListForm.current.length - 2; i++) {
              refBrandListForm.current[i].value = "";
            }
            refPreviewBrandFiles.current = false;
            //refresh menu list
            retrieveBrandList(param);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };

  const editBrandSubmit = (values, actions) => {
    const payload = {
      id: values.id,
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandName: values.name,
      phone: values.phone,
      email: values.email,
      address: values.address,
      serviceType: values.serviceType,
    };
    console.log(payload);
    api.post("Admin/UpdateBrand", payload, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.statusCode === 200) {
            alert("Brand updated successfully!!");
            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowEditBrand(false);

            retrieveBrandList();
            for (let i = 0; i < refBrandListForm.current.length - 2; i++) {
              refBrandListForm.current[i].value = "";
            }
            refPreviewBrandFiles.current = false;
            retrieveBrandList(param);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };


  useEffect(() => {
    retrieveBrandList();
  }, [param]);

  return (

    <>
      {(showAddBrand || showEditBrand) && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">Brand</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          <Formik
            initialValues={showEditBrand ? detailBrand : initialValues}

            enableReinitialize={true}
            validateOnBlur={false}
            validationSchema={AddBrandFormValidation}
            onSubmit={(values, actions) => {
              showEditBrand
                ? editBrandSubmit(values, actions)
                : handleSubmitForm(values, actions);
            }}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form
                ref={refBrandListForm}
                className="row form-container add-brand-form"
              >
                <div className="col-6 mt-2">
                  <CustomInput
                    name="name"
                    type="text"
                    label="Brand Name"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="Enter Brand Name"
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="phone"
                    type="phone"
                    label="Phone Number"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="09-"
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="email"
                    type="email"
                    label="Email"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="example@gmail.com"
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="serviceType"
                    type="text"
                    label="Service Type"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="address"
                    label="Address"
                    textarea="true"
                  />
                </div>
                <div className="form-group mt-4">
                  <div className="Actions justify-content-end">
                    <button
                      type="button"
                      className="button btnCancel"
                      onClick={clickBtnClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      {showAddBrand ? "Create" : "Update"}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          {/* </div>
            </div>
          </div> */}
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Brand</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveBrandList()}
          />
          {!showAddBrand && (
            <CustomButton
              icon={add}
              text="Add Brand"
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddBrand(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container brand_table">
        <Table
          ref={refBrandTable}
          maxBodyHeight={brandList.limit * 100}
          isLoading={brandList.isLoading}
          grouping={brandList.grouping}
          limit={brandList.limit}
          page={brandList.page}
          total={brandList.total}
          data={brandList.data}
          onPageChange={(page) => {
            setParam({
              ...param,
              currentPage: page,
            });
            retrieveBrandList(param);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex = (brandList.page - 1) * brandList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },

            {
              title: "Name",
              render: (row) => {
                if (row.brandName == null || row.brandName == "") {
                  return "Unknown";
                }
                return row.brandName;
              },
              width: "100px",
            },
            {
              title: "Phone Number",
              field: "phone",
              width: "120px",
            },
            {
              title: "Email",
              field: "email",
              width: "100px",
            },
            {
              title: "Address",
              field: "address",
              width: "120px",
            },
            {
              title: "Service Type",
              field: "serviceType",
              width: "120px",
            },

            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) => clickEdit(row)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDelete(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </>

  );
};
export default Brand;
